import * as api from '../services/autoDialOps';

export const AUTODIAL_OPS_LOAD          = 'AUTODIAL_OPS_LOAD';
export const AUTODIAL_OPS_LOADING       = 'AUTODIAL_OPS_LOADING';
export const AUTODIAL_OPS_ERROR         = 'AUTODIAL_OPS_ERROR';
export const AUTODIAL_OPS_SET_AGENT     = 'AUTODIAL_OPS_SET_AGENT';
export const AUTODIAL_OPS_TOGGLE_LIVE   = 'AUTODIAL_OPS_TOGGLE_LIVE';

export const loadOpsData = (agentType) => async (dispatch, getState) => {
  const type = agentType || getState().autoDialOps.agentType;
  dispatch({ type: AUTODIAL_OPS_LOADING });
  try {
    const data = await api.getMisV2(type);
    dispatch({ type: AUTODIAL_OPS_LOAD, payload: { ...data, agentType: type } });
  } catch (err) {
    dispatch({ type: AUTODIAL_OPS_ERROR, payload: err.message });
  }
};

export const setAgentType = (agentType) => (dispatch) => {
  dispatch({ type: AUTODIAL_OPS_SET_AGENT, payload: agentType });
  dispatch(loadOpsData(agentType));
};

export const toggleLive = () => ({ type: AUTODIAL_OPS_TOGGLE_LIVE });

export const triggerManualRedial = (applicationNos, agentType) => async (dispatch) => {
  try {
    const result = await api.manualRedial(applicationNos, agentType);
    dispatch(loadOpsData(agentType));
    return result;
  } catch (err) {
    dispatch({ type: AUTODIAL_OPS_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};
